// Translations
import { KYC_ERROR_DESCRIPTION, KYC_ERROR_TITLE } from '../translations/kyc-error.translations';

const KYC_ERROR_COMPONENT_PROPS = {
  description: KYC_ERROR_DESCRIPTION,
  title: KYC_ERROR_TITLE,
};

export { KYC_ERROR_COMPONENT_PROPS };
